(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){

if (typeof window.TheChurchCo_Utils == 'undefined') window.TheChurchCo_Utils = {};

TheChurchCo_Utils = {

    awaitArray(arr, cb){

        return new Promise(function(resolve,reject){

            function asyncForEach(arr){

                return arr.reduce((promise, item) => {
                    return promise
                    .then(response => {

                        return cb(item);

                    }).catch(e => {

                        console.log(e,"Error");

                    });

                }, Promise.resolve());

            }

            // Run on input
            asyncForEach(arr)
            .then(() => {
                if(arr.length == 1) cb(arr[0]).then(() => resolve());
            })

        })

    }

}




module.exports = TheChurchCo_Utils;

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/Utils.js","/modules")